import React from "react";
import PropTypes from "prop-types";
import { stringify, parse } from "qs";
import { isEqual } from "lodash";

function parseQuery(props) {
  return parse(props.location.search.replace(/^\?/, ""));
}

/**
 * Abstracts away any dependencies on the routing library and allows "route" components to change navigation state
 */
export default function(Component) {
  class RouteWrapper extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        queryChanged: false,
      };
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        queryChanged: !isEqual(parseQuery(this.props), parseQuery(nextProps)),
      });
    }

    redirectTo(path, query) {
      const { history } = this.props;

      history.push({
        pathname: path,
        search: stringify(query),
      });
    }

    updateQuery(key, value) {
      const query = parseQuery(this.props);

      query[key] = value;

      this.replaceQuery(query);
    }

    replaceQuery(query) {
      const { history, location } = this.props;

      history.replace({
        pathname: location.pathname,
        search: stringify(query),
      });
    }

    render() {
      const { queryChanged } = this.state;

      return (
        <Component
          {...this.props}
          query={parseQuery(this.props)}
          queryChanged={queryChanged}
          redirectTo={(path, query) => this.redirectTo(path, query)}
          replaceQuery={query => this.replaceQuery(query)}
          updateQuery={(key, value) => this.updateQuery(key, value)}
        />
      );
    }
  }

  RouteWrapper.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired,
    }),
  };

  RouteWrapper.contextTypes = {
    router: PropTypes.any,
  };

  return RouteWrapper;
}
